module.exports = __webpack_public_path__ + "img/james_potter.ea2a6111.jpg";